import http from "../../http-common";

const get = (data) => http.post("/RelatorioEntregas/PesquisaEntregas", data);

const getDialogData = (data) => http.post("/RelatorioEntregas/PesquisaDadosEntrega", data);

export default { get, getDialogData };
